<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="fecharAlertSucesso($event)">
</app-success-generico>
<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-confirma-exclusao [confirmaExclusao]="alertConfirmacao" (confirmaExclusaoFechou)="fecharAlertConfirmacao($event)">
</app-confirma-exclusao>
<app-error-generico [errorGenerico]="alertError" (alertErrorFechou)="fecharAlertError($event)"></app-error-generico>

@if (dadosContato && dadosContato?.length) {
  <div>
    <div class="row border-top border-bottom pt-3 pb-0 text-nowrap">
      <div class="coluna-lapis">
        <span class="label">EDITAR</span>
      </div>
      <div class="coluna-usuario">
        <span class="label">NOME</span>
      </div>
      <div class="coluna-email">
        <span class="label">E-MAIL</span>
      </div>
      <div class="coluna-telefone">
        <span class="label">TELEFONE</span>
      </div>
      <div class="coluna-lixeira">
        <span class="label">EXCLUIR</span>
      </div>
    </div>
    @for (contato of dadosContato | paginate: { id: 'paginacaoContatos',
      itemsPerPage: contatosPorPagina,
      currentPage: paginaContato,
      totalItems: $safeNavigationMigration(dadosContato?.length) }; track contato) {
      <div class="row border-top pt-3 pb-0">
        <div class="coluna-lapis">
          <button class="btn pt-0" id="btnEditarContato" (click)="editarContato(contato.idContatCnt)"
            [disabled]="!('CadastrosDadosDaEmpresa' | usuarioPermissao:'Alterar' | async)">
            <i class="fa fa-pencil c-primary" aria-hidden="true"></i>
          </button>
        </div>
        <div class="coluna-usuario">
          <p class="paragrafo">{{contato.nmContatCnt | camelCase}}</p>
        </div>
        <div class="coluna-email">
          <p class="paragrafo">{{contato.dsEmailsEma}}</p>
        </div>
        <div class="coluna-telefone">
          <p class="paragrafo">({{contato.cdTeldddTel}}) {{contato.cdTelnumTel}}</p>
        </div>
        <div class="coluna-lixeira">
          <button class="btn pt-0" id="btnExcluirContato" (click)="confirmarExclusaoContato(contato.idContatCnt)"
            [disabled]="!('CadastrosDadosDaEmpresa' | usuarioPermissao:'Excluir' | async)">
            <i class="fa fa-trash c-primary" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    }
  </div>
}

<!-- FOOTER-CARD - PAGINAÇÃO - EMPRESAS -->
@if (dadosContato && dadosContato?.length) {
  <div class="footer-card">
    <div>
      <app-select [value]="contatosPorPagina" (valueChanges)="onContatosPorPaginaChange($event)"
      name="contatosPorPaginaName" [options]="[
      {name : 'Exibir 3 contatos' , value : '3'} ,
      {name : 'Exibir 6 contatos' , value : '6'} ,
      {name : 'Exibir 9 contatos' , value : '9'}

      ]" optionValue="value" optionText="name">
      </app-select>
    </div>
    <!-- Paginação CENTRAL -->
    <div>
      <pagination-controls class="my-pagination" id="paginacaoContatos" directionLink="true"
        (pageChange)="paginaContato = $event" responsive="true" previousLabel="Anterior" nextLabel="Próxima">
      </pagination-controls>
    </div>
    <div>
      <p><span class="itens-pagina">{{dadosContato.length}}</span> Registros foram encontrados</p>
    </div>
  </div>
}
@if (dadosContato && dadosContato?.length) {
  <div class="d-flex container-fluid justify-content-center m-0 p-0 mt-5">
    <button class="botao px-5" id="btnNovoContato" routerLink="/adicionar-contato"
    [disabled]="!('CadastrosDadosDaEmpresa' | usuarioPermissao:'Incluir' | async)">NOVO</button>
  </div>
}
<!-- CARREGAMENTO EMPRESAS -->
@if (dadosContato === null) {
  <div>
    <div class="text-center">
      <output class="spinner-border c-primary">
        <span class="visually-hidden">Consultando contatos da empresa ...</span>
      </output>
    </div>
    <p class="legenda-spinner">Consultando contatos da empresa ...</p>
  </div>
}

<!-- CASO DE ERRO EMPRESAS -->
@if (dadosContato === false) {
  <div class="text-center">
    <img src="/assets/img/erro.png" width="200px" alt="Erro">
    <p class="legenda-erro">Ocorreu um erro na consulta de contatos da empresa.</p>
  </div>
}

<!-- CASO DE ESTEJA VAZIO -->
@if (!dadosContato?.length && dadosContato !== null) {
  <div class="text-center">
    <img src="/assets/img/vazio.png" width="230px" alt="nao existem contatos.">
    <p class="legenda-vazio">Não existem contatos para essa consulta.</p>
    <div class="d-flex container-fluid m-0 p-0  mt-4 justify-content-center">
      <button class="botao px-5" routerLink="/adicionar-contato">NOVO</button>
    </div>
  </div>
}